import { message as staticMessage } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';

let appMessageApi: MessageInstance | undefined;

export const setAppMessageApi = (messageApi: MessageInstance) => {
  appMessageApi = messageApi;
};

export const message = {
  success: (...args: Parameters<MessageInstance['success']>) =>
    appMessageApi ? appMessageApi.success(...args) : staticMessage.success(...args),
  error: (...args: Parameters<MessageInstance['error']>) =>
    appMessageApi ? appMessageApi.error(...args) : staticMessage.error(...args),
  warning: (...args: Parameters<MessageInstance['warning']>) =>
    appMessageApi ? appMessageApi.warning(...args) : staticMessage.warning(...args),
  info: (...args: Parameters<MessageInstance['info']>) =>
    appMessageApi ? appMessageApi.info(...args) : staticMessage.info(...args),
  loading: (...args: Parameters<MessageInstance['loading']>) =>
    appMessageApi ? appMessageApi.loading(...args) : staticMessage.loading(...args),
  open: (...args: Parameters<MessageInstance['open']>) =>
    appMessageApi ? appMessageApi.open(...args) : staticMessage.open(...args),
  destroy: (...args: Parameters<MessageInstance['destroy']>) =>
    appMessageApi ? appMessageApi.destroy(...args) : staticMessage.destroy(...args)
};
